import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Theme, Grid } from '@material-ui/core';
import ConnectedBasicData from '../basicdata/ConnectedBasicData';
import ConnectedResult from '../result/ConnectedResult';
import ConnectedHub from '../hub/ConnectedHub';
import ConnectedShaft from '../shaft/ConnectedShaft';
import ConnectedClampingElement from '../clampingelement/ConnectedClampingElement';
import ConnectedControlButtons from '../bottombuttons/ConnectedControlButtons';
import ConnectedHubCValue from '../cvalue/ConnectedHubCValue';
import { ClampexType } from '../../types/types';
import { Panel } from '@ktr/ktr-materialui-react';
import { useIntl } from 'react-intl';

const useStyle = makeStyles((theme: Theme) =>
    createStyles({
        root: {
        },
        '@media (min-width: 200px)': {
            root: {
            },
        },
        basicDataPanel: {
            marginLeft: "40px",
            marginTop: "20px",
            marginRight: "40px"
        },
        container: {
            //maxWidth: "1100px"
        },
        buttonsGrid: {
            marginTop: "10px"
        },
        hr: {
            //backgroundColor: theme.palette.third.main,
            height: "1px",
            marginTop: "10px",
            border: "none",
            //@ts-ignore
            backgroundImage: "linear-gradient(to right, rgba(0, 0, 0, 0), " + theme.palette.third.main + ", rgba(0, 0, 0, 0))"
        },
        productSelect: {
            color: "#000000",
            marginRight: "10px",

            '&:before': {
                border: "none",
            },
            '&:hover:before': {
                border: "none",
            },
            '&:hover:not(.Mui-disabled):before': {
                border: "none"
            }
        },
        selectInput: {
            color: "#ffffff",
        },
        grid1: {
            marginLeft: "20px",
            fontSize: "1.1em",
            color: "#000000"
        }
    }));


interface Props {
    clampexType: ClampexType
}

export default function MainContainer(props: Props) {
    const classes = useStyle();
    const { formatMessage: f } = useIntl();
    //const [currentClampexType, setCurrentClampexType] = React.useState(ClampexType[props.clampexType]); //This state is only for the initial state of the dropdown for product change


    //everytime the product changes change also the currentClampexType
   /* useEffect(() => {
        setCurrentClampexType(ClampexType[props.clampexType]);
    }, [props.clampexType])
*/
    //on product change navigate to the new product site
   /* const onProductChange = (e: any) => {
        console.log(e.target.value);
        var link = window.document.createElement('a');
        link.href = "#/" + e.target.value;
        document.body.appendChild(link);
        //open url in new window 
        link.click();
        //remove link element from body
        document.body.removeChild(link);
        //Page refresh
        window.location.reload();

    }*/


    return (
        <React.Fragment>
            <CssBaseline />
            <Container className={classes.container}>    
                <Grid container >
                    <Grid item xs={12}>
                        <ConnectedClampingElement />
                    </Grid>
                    <Grid item xs={12} sm={true}>
                        <Panel title={<b>{f({ id: 'app.containerBasicLabel' })}</b>}>
                            <ConnectedBasicData />
                            <ConnectedShaft />
                            { //when KTR700 is selected we dont need the Hub element.
                                props.clampexType !== ClampexType.KTR700 ?
                                    <Grid item xs={12} sm={true}>
                                        <ConnectedHub />
                                    </Grid>
                                    : ""
                            }
                        </Panel>
                    </Grid>
                    {props.clampexType !== ClampexType.KTR700 ?
                        <Grid item xs={12} sm={12}>
                            <ConnectedHubCValue />
                        </Grid>
                        : ""
                    }
                    <Grid className={classes.buttonsGrid} item xs={12}>
                        <ConnectedControlButtons />
                    </Grid>
                    <Grid item xs={12}>
                        <hr className={classes.hr} />
                        <ConnectedResult />
                    </Grid>
                </Grid>
            </Container>
        </React.Fragment>
    );
}